import { render, staticRenderFns } from "./DefaultQuestion.vue?vue&type=template&id=f25a5622&scoped=true&"
import script from "./DefaultQuestion.vue?vue&type=script&lang=js&"
export * from "./DefaultQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DefaultQuestion.vue?vue&type=style&index=0&id=f25a5622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25a5622",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
